import Vue from 'vue'
import router from '../router'
import VueResource from 'vue-resource'
Vue.use(VueResource)



export default {

  user: {
    login: '',
    authenticated: false,
    tokenExpire: '',
    token: '',
    userGuid: '',
    roles: [],
    permissions: []
  },
  errorHandler(err, context) {
    if (err.status == 401) {
      this.logout()
      router.replace('/login')
    } else
      this.showToast(context, this.err)
    console.log(err)
  },

  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  },

  post(context, method, body, toast = false, contentType = '') {
    let symbol = method.indexOf("&") > 0 ? "" : "?"
    return context.$http.post(method + symbol + 'token=' + this.user.token, body, {
      headers: {
        'Content-Type': contentType == '' ? 'application/json' : contentType
      }
    }).then((data) => {
      this.data = {
        status: data.status,
        data: JSON.parse(data.bodyText == '' ? '{}' : data.bodyText)
      }

      if (toast)
        this.showToast(context, this.data)
      return this.data
    })
      .catch(err => {
        this.err = {
          status: err.status,
          data: JSON.parse(err.bodyText == '' ? '{}' : err.bodyText)
        }
        this.errorHandler(this.err, context)
        return this.err
      })
  },

  get(context, method, body = '', toast = false) {
    return context.$http.get(method + (body == '' ? '?' : body + '&') + 'token=' + this.user.token, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((data) => {
      this.data = {
        status: data.status,
        data: JSON.parse(data.bodyText == '' ? '{}' : data.bodyText)
      }

      if (toast)
        this.showToast(context, this.data)
      return this.data
    })
      .catch(err => {
        this.err = {
          status: err.status,
          data: JSON.parse(err.bodyText == '' ? '{}' : err.bodyText)
        }
        this.errorHandler(this.err, context)
      })
  },

  login(context, body) {
    let request = this.post(context, '/api/User/Login', body)
    request.then((response) => {
      let data = response.data
      localStorage.setItem('token', data.Token)
      localStorage.setItem('tokenExpire', data.ExpiredAt)
      localStorage.setItem('userGuid', data.UserGuid)
      localStorage.setItem('login', data.Login)
      localStorage.setItem('roles', JSON.stringify(data.Roles))
      localStorage.setItem('permissions', JSON.stringify(data.Permissions))

      this.user.authenticated = true
      this.user.token = data.Token
      this.user.tokenExpire = data.ExpiredAt
      this.user.userGuid = data.UserGuid
      this.user.login = data.Login
      this.user.roles = data.Roles
      this.user.permissions = data.Permissions

    
      // router.push(data.Permissions[0].Pages[0].Path)

    }, (err) => errorHandler(err))
    return request;
  },

  //Admin Tools
  getSMSCode(context, body) {
    return this.post(context, '/api/AdminTools/GetSMSCode', body);
  },
  getUserRoles(context, body) {
    return this.post(context, '/api/AdminTools/GetUserRoles', body);
  },
  getRoles(context) {
    return this.get(context, '/api/AdminTools/Roles');
  },
  changeRole(context, body) {
    return this.post(context, '/api/AdminTools/ChangeRole', body, true);
  },
  changePassword(context, body) {
    return this.post(context, '/api/AdminTools/ChangePassword', body, true);
  },

  //USERS
  getAgents(context, body) {
    return this.post(context, '/api/Main/GetAgentsList', body);
  },
  getCashiers(context, body) {
    return this.post(context, '/api/Main/GetCashiersList', body);
  },
  cashOutToCashier(context, body) {
    return this.post(context, '/api/Main/CashOutToCashier', body, true);
  },
  cashOutToAgent(context, body) {
    return this.post(context, '/api/Main/CashOutToAgent', body, true);
  },
  changeUserData(context, body) {
    return this.post(context, '/api/Main/ChangeUserData', body, true);
  },
  registerUser(context, body) {
    return this.post(context, '/api/User/RegisterUser', body, true);
  },
  findUser(context, body) {
    return this.get(context, '/api/User/FindUser?query=', body);
  },
  balance(context) {
    return this.get(context, '/api/User/Balance');
  },
  exportToExcel(context, body) {
    return this.post(context, '/api/Report/HistoryToExcel', body, true);
  },


  //Notifications
  sentNotyToAll(context, body) {
    return this.post(context, '/api/Notification/SentToAll', body);
  },
  sentNotyToUser(context, body) {
    return this.post(context, '/api/Notification/SentToUser', body);
  },

  //Reports

  // getTechnicalReport(context, body) {
  //   return this.post(context, '/api/Report/Technical', body);
  // },
  getTransactionLog(context, body) {
    return this.post(context, '/api/Report/Log', body);
  },
  getLastHistory(context, body) {
    return this.post(context, '/api/Report/LastHistory', body);
  },
  getSummaryByRegion(context, body) {
    return this.post(context, '/api/Report/SummaryByRegion', body);
  },
  getSummaryByOperator(context, body) {
    return this.post(context, '/api/Report/SummaryByOperator', body);
  },
  getSummaryByTariff(context, body) {
    return this.post(context, '/api/Report/SummaryByTariff', body);
  },
  getFinancialReport(context, body) {
    return this.post(context, '/api/Report/Financial', body);
  },
  getTuaReport(context, body) {
    return this.post(context, '/api/Report/Tua', body);
  },
  getNonBillingReport(context, body) {
    return this.post(context, '/api/Report/NonBilling', body);
  },
  
  getGeneralReport(context, body) {
    return this.post(context, '/api/Report/General', body);
  },

  getRemittanceReport(context, body) {
    return this.post(context, '/api/Report/Remittance', body);
  },
  changePaymentState(context, body) {
    return this.post(context, '/api/TransactionsQueue/Change', body, true);
  },
  transactionDetails(context, body) {
    return this.post(context, '/api/Report/Details', body);
  },

  getLocations(context, body) {
    return this.post(context, '/api/User/Locations', body);
  },
  getAllLocations(context) {
    return this.get(context, '/api/User/GetAllLocations');
  },

  getUserLimit(context, body) {
    return this.post(context, '/api/User/UserLimit', body);
  },
  saveUserLimit(context, body) {
    return this.post(context, '/api/User/SaveLimit', body, true);
  },
  dashboard(context) {
    return this.get(context, '/api/Main/Dashboard');
  },
  getRemittanceInfo(context, body) {
    return this.post(context, '/api/Remittance/RemittanceInfo', body);
  },
  acceptRemittance(context, body) {
    return this.post(context, '/api/Remittance/Remittance', body, true);
  },


  //Charts
  getAgentsCollected(context, body) {
    return this.post(context, 'api/Chart/AgentsCollected', body);
  },
  // getSalesAndProfitByProviders(context, body) {
  //   return this.post(context, 'api/Chart/SalesAndProfitByProviders', body);
  // },
  // getSalesAndProfitDynamicsByProviders(context, body) {
  //   return this.post(context, 'api/Chart/SalesAndProfitDynamicsByProviders', body);
  // },
  // getSalesAndAgentsDepositesDynamic(context, body) {
  //   return this.post(context, 'api/Chart/SalesAndAgentsDepositesDynamic', body);
  // },
  // getAgentsDepositsAndProfitBalance(context, body) {
  //   return this.post(context, 'api/Chart/AgentsDepositsAndProfitBalance', body);
  // },
  // getSalesByAirtimeCredit(context, body) {
  //   return this.post(context, 'api/Chart/SalesByAirtimeCredit', body);
  // },
  // getNumberOfTUAAccounts(context, body) {
  //   return this.post(context, 'api/Chart/NumberOfTUAAccounts', body);
  // },
  // getMonthlyTotalSales(context, body) {
  //   return this.post(context, 'api/Chart/MonthlyTotalSales', body);
  // },
  // getAgentsSales(context, body) {
  //   return this.post(context, 'api/Chart/AgentsSales', body);
  // },


  showToast(context, data) {
    if (data.status == 200)
      context.$toast.success({
        title: 'Successfully!',
        message: data.data.Message,

      })
    else if (data.status >= 400)
      context.$toast.error({
        title: 'Error!',
        message: data.data.Message,

      })
  },
  //////////////////
  logout() {
    localStorage.removeItem('token')
    localStorage.removeItem('userGuid')
    localStorage.removeItem('login')
    localStorage.removeItem('roles')
    localStorage.removeItem('permissions')
    this.user.authenticated = false
  },

  checkAuth() {

    let tokenExpiredAt = localStorage.getItem('tokenExpire')
    let dateTimeNow = Date.now() / 1000;
    this.user.authenticated = (localStorage.getItem('tokenExpire') != "" && localStorage.getItem('tokenExpire') != null && tokenExpiredAt > dateTimeNow);
    if (this.user.authenticated) {
      this.user.token = localStorage.getItem('token');
      this.user.tokenExpire = localStorage.getItem('tokenExpire');
      this.user.userGuid = localStorage.getItem('userGuid');
      this.user.login = localStorage.getItem('login');
      this.user.roles = JSON.parse(localStorage.getItem('roles'));
      this.user.permissions = JSON.parse(localStorage.getItem('permissions'));
    }
  }

}



// WEBPACK FOOTER //
// ./src/api/index.js